import Query from '../../../components/Report';

const query = ({ project_id, cluster_name, intent_filter = '' }) =>
    new Query('commerce-detail-cluster-common-urls', {
        project_id,
        cluster_name,
        intent_filter: setIntent(intent_filter),
    });

export default query;

function setIntent(intent_filter) {
    if (!intent_filter || intent_filter?.length === 0) return '';

    return `and (${intent_filter?.map((item) => `dck.intent LIKE '%${item}%'`).join(' or ')})`;
}
